<template>
    <nuxt-link ref="bannerRef" :to="banner.url" class="banner" :class="resolveColorVariantCssVariant(banner)">
        <!--        <div class="banner__container">-->
        <img class="banner__image" :src="banner.cdnImage" :alt="banner.title" />
        <div class="banner__info">
            <h2 :style="banner.titleColor ? `color: ${banner.titleColor};` : ''">{{ banner.title }}</h2>
            <p v-if="banner.description">{{ banner.description }}</p>
            <button v-if="banner.cta">{{ banner.cta }}</button>
        </div>
        <!--        </div>-->
    </nuxt-link>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import BannerTile from '~/models/Category/BannerTile'
import { useMatomoViewportTrack, useMatomoClickTrack } from '~/composables/useMatomo'

const props = defineProps({
    banner: {
        type: Object as PropType<BannerTile>,
        required: true,
    },
})

const bannerRef = ref<any | null>(null)

onMounted(() => {
    if (bannerRef.value.$el) {
        useMatomoViewportTrack(bannerRef.value.$el, {
            category: 'SubcategoryTileBanner',
            action: 'view',
            name: props.banner.title,
            value: parseInt(props.banner.id + ''),
        })

        useMatomoClickTrack(bannerRef.value.$el, {
            category: 'SubcategoryTileBanner',
            action: 'click',
            name: props.banner.title,
            value: parseInt(props.banner.id + ''),
        })
    }
})

const resolveColorVariantCssVariant = (banner: BannerTile) => {
    if (banner.colorVariant === 'white') {
        return 'banner--white'
    }
    if (banner.colorVariant === 'brand') {
        return 'banner--brand'
    }

    return 'banner--dark'
}
</script>

<style lang="scss" scoped>
.banner {
    position: relative;
    color: $color-dark;
    max-height: 240px;
    display: flex;
    justify-content: end;

    &__image {
        max-height: 240px;
        justify-self: end;
        border-radius: 16px;
    }

    &__info {
        position: absolute;
        top: 0;
        left: 15px;
        right: 40%;
        bottom: 0;
        height: 100%;
        width: auto;
        //height: 120%;
        //width: 57%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: start;
        gap: 5px;
        //padding: 20px 15px 0;
        //position: relative;
        z-index: 9;

        @include screen-md {
            left: 25px;
            right: 40%;
            gap: 10px;
        }

        h2 {
            font-family: 'scale-variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',
                'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
            font-variation-settings: 'wght' 500, 'wdth' 125;
            font-size: 17px;
            line-height: 19px;
            margin: 0 0 0;

            @include screen-md {
                font-size: 26px;
                line-height: 30px;
            }
        }

        p {
            font-family: 'scale-variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',
                'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
            font-variation-settings: 'wght' 300, 'wdth' 100;
            font-size: 13px;
            line-height: 15px;
            margin: 0;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-line-clamp: 2;
            max-width: 80%;

            @include screen-md {
                font-size: 17px;
                line-height: 21px;
            }
        }

        button {
            background: $color-secondary-dark-green-1;
            color: $color-secondary-accent-green;
            border-radius: 35px;
            padding: 4px 8px;
            font-weight: 500;
            font-size: 13px;
            margin-top: 0;
            cursor: pointer;

            @include screen-md {
                font-size: 16px;
                padding: 8px 16px;
            }
        }
    }

    &--white {
        .banner__info {
            h2 {
                color: $color-white;
            }

            p {
                color: $color-white;
            }

            button {
                background: $color-white;
                color: $color-secondary-dark-green-1;
            }
        }
    }

    &--dark {
        .banner__info {
            h2 {
                color: #004840;
            }

            p {
                color: #004840;
            }

            button {
                background: $color-secondary-dark-green-1;
                color: $color-secondary-accent-green;
            }
        }
    }

    &--brand {
        .banner__info {
            h2 {
                color: $color-primary-pink;
            }

            p {
                color: $color-white;
            }

            button {
                background: $color-primary-pink;
                color: $color-primary-green;
            }
        }
    }

    &:hover {
        button {
            background: $color-secondary-accent-green;
            color: $color-primary-green;
        }
    }
}
</style>
